<template>
    <MasonryWall
        v-if="mode === 'masonry' && items"
        :items="items"
        :column-width="columnWidth"
        :gap="gap"
        :ssr-columns="ssrColumns"
    >
        <template #default="{ item, index }">
            <slot :item="item" :index="index" />
        </template>
    </MasonryWall>

    <div v-else class="card-grid">
        <slot :item="undefined" :index="-1" />
    </div>
</template>

<script setup lang="ts" generic="T">
interface Props {
    columns?: number
    gap?: number
    columnWidth?: number
    mode?: 'masonry' | 'grid'
    items?: T[]
    ssrColumns?: number
    fullWidth?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    columns: 4,
    gap: 24,
    columnWidth: 300,
    mode: 'grid',
    ssrColumns: 1,
    fullWidth: false
})

defineSlots<{
    default(props: { item: any; index: number }): any
}>()

const gridColumns = computed(() => props.columns)
const gridGap = computed(() => `${props.gap}px`)
</script>

<style scoped>
.card-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: v-bind(gridGap);
}

@media (min-width: 620px) {
    .card-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 920px) {
    .card-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 1220px) {
    .card-grid {
        grid-template-columns: repeat(v-bind(gridColumns), 1fr);
    }
}
</style>
